import { render, staticRenderFns } from "./inventory-configuration.vue?vue&type=template&id=1028c040&scoped=true&"
import script from "./inventory-configuration.vue?vue&type=script&lang=js&"
export * from "./inventory-configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1028c040",
  null
  
)

export default component.exports